// extracted by mini-css-extract-plugin
module.exports = {"align_center":"PersonalData_align_center__2r4rm","form":"PersonalData_form__3oR1m"};